import React, { useMemo } from 'react';
import './index.scss';

interface LoadingDotsProps {
  text?: string;
  showText?: boolean;
  dotColor?: string;
}

/**
 * 加载中动画组件
 * 显示三个动画点和可选的文本
 * @param {Object} props - 组件属性
 * @param {string} [props.text] - 显示的文本，默认为"加载中..."
 */
const LoadingDots: React.FC<LoadingDotsProps> = function (props) {
  const {
    text = '加载中...',
    showText = true,
    dotColor = 'rgba(35,37,42,0.5)'
  } = props;

  /**
   * 加载动画点的行内样式
   */
  const loadingDotsStyle = useMemo(
    () => ({
      backgroundColor: dotColor
    }),
    [dotColor]
  );

  return (
    <React.Fragment>
      <span className="loading-dot" style={loadingDotsStyle}></span>
      <span className="loading-dot" style={loadingDotsStyle}></span>
      <span className="loading-dot" style={loadingDotsStyle}></span>
      {showText && text}
    </React.Fragment>
  );
};

export default LoadingDots;
